import { toExcelDate } from 'components/xlsx/excelCells';
import { ClassifierData } from 'types/classifiers';
import { NominationListItem } from 'types/efforts';
import { getClassifierText, t } from 'utils/getTranslations';

/** The Rankings referees list's rows as the export writes them: one row a nomination, the columns the list shows. */
export const mapRankingsRefereesToCSVFormat = (
    nominations: NominationListItem[],
    classifiers: Record<string, ClassifierData>
) =>
    nominations.map((nomination) => ({
        [t('rankings-referees.columns.referee')]: nomination.referee?.name ?? '',
        // One entry per name, as `referee.companyNames`, which the search matches, joins them.
        [t('rankings-referees.columns.company')]: [...new Set(nomination.companies.map(({ name }) => name))].join(', '),
        [t('rankings-referees.columns.directory')]: getClassifierText(
            classifiers['LEGAL_DIRECTORY'],
            nomination.legalDirectoryCode
        ),
        [t('rankings-referees.columns.edition')]: nomination.editionYear,
        [t('rankings-referees.columns.practice-area')]: nomination.practiceArea?.name ?? '',
        [t('rankings-referees.filter.requested-by')]: nomination.requestedBy?.name ?? '',
        [t('rankings-referees.columns.requested')]: toExcelDate(nomination.requestedOn),
        [t('rankings-referees.columns.status')]: t(`rankings-referees.status.${nomination.statusCode}`),
    }));
